module.exports = __webpack_public_path__ + "img/ปลาทูน่า.60654442.jpeg";